import React from 'react';
import { grey } from '@mui/material/colors';
import { useHistory } from 'react-router-dom';
import { SearchOff } from '@mui/icons-material';
import { Stack, Typography, Button } from '@mui/material';

export const ProposalNotFound = () => {
  const history = useHistory();

  return (
    <Stack alignItems="center" justifyContent="center" height="80vh">
      <SearchOff sx={{ color: grey['600'], fontSize: '8rem' }} />

      <Typography sx={{ fontSize: '2.25rem' }} variant="h6" component="span" color="textSecondary">
        Proposal not found
      </Typography>

      <Button
        size="large"
        variant="contained"
        onClick={() => {
          history.replace('/');
        }}
      >
        Back
      </Button>
    </Stack>
  );
};
